// Handle videos in apage
(function($){

    $(document).on("click", '.card--has-video .card__image', function(e) { 
        e.preventDefault();
        e.stopPropagation();
        var videoCard = $(this).parents('.card--has-video');
        var videoContainer = videoCard.find('.card__embed__video__container');
        var videoEmbedCode = videoContainer.data('videocode');
        var currentVideoCard = $('.card--video-loaded');
        var currentVideoContainer = currentVideoCard.find('.card__embed__video__container');

        currentVideoCard.removeClass('card--video-loaded').find('.image-hidden').removeClass('image-hidden');
        currentVideoContainer.addClass('video-hidden').data('videocode', escape(currentVideoContainer.html())).html('');
        videoCard.find('.card__image').addClass('image-hidden');
        videoContainer.html(unescape(videoEmbedCode)).promise().done(function(){
            videoCard.addClass('card--video-loaded');
            videoContainer.removeClass('video-hidden');
        });
            

    });

})(jQuery);
